/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { FormattedNumber } from 'react-intl'

export type FormattedFileSizeProps = {
  value: number
}

function FormattedFileSize (props: FormattedFileSizeProps) {
  const { value } = props
  let unit = 'byte'
  let size = value

  if (value >= 1000000000000) {
    unit = 'tera'
    size = value / 1000000000000
  } else if (value >= 1000000000) {
    unit = 'gigabyte'
    size = value / 1000000000
  } else if (value >= 1000000) {
    unit = 'megabyte'
    size = value / 1000000
  } else if (value >= 1000) {
    unit = 'kilobyte'
    size = value / 1000
  }
  return (
    <FormattedNumber
      value={Math.round(size * 100) / 100}
      style="unit"
      unit={unit}
    />
  )
}

export default FormattedFileSize
